<template>
  <div class="pagination-container">
    <div>
      <a :class="previousButtonClass"
         title="Previous Page"
         v-if="this.displayPreviousPageButton"
         @click.prevent="showPreviousPage">
        <img :src="this.enablePreviousPageButtonURL" class="pagination-icon" alt="previous" title="Previous Page">
      </a>
    </div>
    <div>
      <a title="Next Page"
         :class="nextButtonClass"
         v-if="this.displayNextPageButton"
         @click.prevent="showNextPage">
        <img :src="this.enableNextPageButtonURL" class="pagination-icon" alt="next" title="Next Page">
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "AcclaroPaginationLight",
  props: [
    "paginationDetails",
    "showPreviousPage",
    "showNextPage",
  ],
  computed: {
    displayPreviousPageButton () {
      return this.paginationDetails.current !== 0;
    },
    lastPage(){
      if (this.paginationDetails.total !== 0){
          return Math.floor(this.paginationDetails.total / this.paginationDetails.offset)
      }
      return undefined;
    },
    displayNextPageButton () {
        return this.paginationDetails.total - this.paginationDetails.current > this.paginationDetails.offset;
    },
    previousButtonClass () {
      return this.displayPreviousPageButton ? 'pagination-button' : 'pagination-button-disabled';
    },
    nextButtonClass () {
      return this.displayNextPageButton ? 'pagination-button' : 'pagination-button-disabled';
    },
    enablePreviousPageButtonURL () {
      if (this.paginationDetails.current !== 0) {
        return `/images/notifications/pagination-previous.svg`;
      }
      return `/images/notifications/pagination-previous-disabled.svg`;
    },
    enableNextPageButtonURL () {
      if (this.paginationDetails.current !== this.lastPage) {
        return `/images/notifications/pagination-next.svg`;
      }
      return `/images/notifications/pagination-next-disabled.svg`;
    },
  },
};
</script>

<style scoped>

.pagination-button {
  position: relative;
  display: block;
  color: #767575;
  font-size: 15px;
  margin-left: -1px;
  line-height: 1.25;
  cursor: pointer;
}

.pagination-container {
  display: flex;
  justify-content: center;
  padding-left: 75px;
  margin-top: 10px;
}


.pagination-button-disabled {
  color: #DBD7D7;
  cursor: not-allowed;
  position: relative;
  display: block;
  font-size: 15px;
  margin-left: -1px;
  line-height: 1.25;
}

.pagination-icon {
  width: 28px;
}

</style>
